import HomeLink from "./HomeLink";
import { TokenXfer } from "./TokenXfer";

export default function Purchase(props: any) {
    const clickPurchase = async () => {
        console.log('purchasing...');
        await TokenXfer('7KQWkLzkCqvncLPxZufEoKcPo8Zyf3EmhJUXChukr5EZ', 'CZLcs7eaN3c9uUrZCKgZpSkT6FwwYrV7tNtb3oZ522ZP', 1);
    }

    let nft = 1;
    let price = 0.01;

    return (
        <div className="App-header" style={{display: 'flex', gap: '15px'}}>
            <div>Purchase Biznessmen #{nft}</div>
            <img alt='' src={'forsale/biznessmen-' + nft + '.png'}/>
            <div>WL Price: {price} SOL</div>
            <button style={{padding: '10px'}} onClick={clickPurchase}>Purchase this NFT</button>
            <HomeLink/>
        </div>
    )
}